import React from "react";

var img1 = require("./../../images/background/ptn-1.png");

const experiencePoints = [
  "Three decades of expertise in building material distribution",
  "Deep understanding of construction industry needs and trends",
  "Proven track record of successful partnerships and project completions",
  "Continuous innovation and adaptation to market demands",
];

const leadershipTeam = [
  {
    name: "Jugal Kishore Kumawat",
    position: "CEO and Founder",
    image: "/assets/media/video/avtar.png",
    description:
      "Visionary leader with 30+ years in building materials industry",
  },
  {
    name: "Rohit Kumawat",
    position: "CA and CFO",
    image: "/assets/media/video/avtar.png",
    description:
      "Financial strategist ensuring operational excellence and growth",
  },
  {
    name: "Aditya Kumawat ",
    position: "Chief Sales & Marketing",
    image: "/assets/media/video/avtar.png",
    description:
      "Visionary leader with 15+ years in building materials industry",
  },
];

class WhyChooseUs extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full p-tb80 bg-gray bg-repeat square_shape2 inner-page-padding"
          style={{ backgroundImage: "url(" + img1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head text-center">
              <div className="mt-separator-outer separator-center">
                <div className="mt-separator">
                  <h2 className="text-uppercase sep-line-one">
                    <span className="font-weight-300 text-primary">Why</span>{" "}
                    Choose Us
                  </h2>
                </div>
                <p className="lead">
                  Building trust through excellence, innovation and unmatched
                  expertise in the building materials industry
                </p>
              </div>
            </div>
            {/* TITLE END */}

            {/* EXPERIENCE SECTION */}
            <div className="section-content m-b50">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div
                    className="experience-card"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "15px",
                      padding: "40px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      border: "1px solid #e9ecef",
                      height: "100%",
                    }}
                  >
                    <div
                      className="experience-badge m-b20"
                      style={{
                        background: "linear-gradient(135deg, #007bff, #0056b3)",
                        color: "white",
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        fontWeight: "bold",
                        boxShadow: "0 5px 20px rgba(0,123,255,0.3)",
                        margin: "0 auto 20px auto",
                      }}
                    >
                      30+
                    </div>
                    <h3
                      className="text-center m-b20"
                      style={{ color: "#2c3e50", fontSize: "24px" }}
                    >
                      Years of Excellence
                    </h3>
                    <p
                      className="text-center m-b20"
                      style={{
                        color: "#6c757d",
                        fontSize: "16px",
                        lineHeight: "1.6",
                      }}
                    >
                      Three decades of unparalleled expertise in building
                      material distribution, serving the construction industry
                      with dedication and innovation.
                    </p>
                    <ul className="list-unstyled">
                      {experiencePoints.map((point, index) => (
                        <li
                          key={index}
                          className="m-b10 d-flex align-items-start"
                        >
                          <i
                            className="fa fa-check-circle text-primary m-r10 m-t5"
                            style={{ fontSize: "16px" }}
                          ></i>
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#495057",
                              lineHeight: "1.5",
                            }}
                          >
                            {point}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* LEADERSHIP TEAM SECTION */}
            <div className="section-content">
              <div className="section-head text-center m-b50">
                <h3
                  className="text-uppercase"
                  style={{
                    color: "#2c3e50",
                    fontSize: "28px",
                    marginBottom: "10px",
                  }}
                >
                  <span className="font-weight-300 text-primary">Our</span>{" "}
                  Leadership Team
                </h3>

                <p
                  style={{
                    color: "#6c757d",
                    fontSize: "16px",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  Experienced professionals driving innovation and excellence in
                  building material distribution
                </p>
              </div>

              <div className="row justify-content-center">
                {leadershipTeam.map((member, index) => (
                  <div key={index} className="col-lg-4 col-md-6 col-sm-6 m-b30">
                    <div
                      className="team-card"
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "15px",
                        padding: "30px",
                        textAlign: "center",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        border: "1px solid #e9ecef",
                        transition: "all 0.3s ease",
                        height: "100%",
                      }}
                    >
                      <div className="team-photo m-b20">
                        <div
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            margin: "0 auto",
                            overflow: "hidden",
                            border: "4px solid #f8f9fa",
                            boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                          }}
                        >
                          <img
                            src={member.image}
                            alt={member.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontSize: "20px",
                          fontWeight: "600",
                          marginBottom: "8px",
                        }}
                      >
                        {member.name}
                      </h4>
                      <h6
                        style={{
                          color: "#007bff",
                          fontSize: "14px",
                          fontWeight: "500",
                          marginBottom: "15px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {member.position}
                      </h6>
                      <p
                        style={{
                          color: "#6c757d",
                          fontSize: "14px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        {member.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default WhyChooseUs;
